<template>
  <div class="containerBanner mb40">
    <div class="container subContainer">
      <div class="containerLeft">
        <img
          v-if="this.windowWidth > 700"
          class="logo"
          src="../assets/logo-blue.svg"
        />
        <img v-else class="logo" src="../assets/icon.png" />

        <span class="darkBlue pf10">
          Gérer son activité n'a jamais été aussi simple
        </span>
      </div>

      <div class="containerLeft">
        <i class="fa fa-lock green" aria-hidden="true"></i>
        <span class="darkBlue pf10">Espace sécurisé</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner_sinao",
  props: {},
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  created() {},
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style>
.containerBanner {
  width: 100%;
  height: 40px;
  background-color: #ffffff;
}

.subContainer {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.containerLeft {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.logo {
  height: 20px;
  width: auto;
}

i {
  width: 14px;
  height: 14px;
}
</style>
